import { DARK_GREEN_OPPS, DARK_RED_OPPS } from '../pages/opportunitiesByChannel/constants';
import { perc2color } from './colors';

const LIGHT_GREEN = '#e6fae6';
const DARK_GREEN = '#05c505';
const LIGHT_RED = '#ffe7e7';
const DARK_RED = '#fc0c0c';

// Spend = no color
// Opportunities Generated =  -1 (less is bad)
// Opportunities Closed = -1 (less is bad)
// Sales = -1 (less is bad)
// Cost per Opportunity = 1 (more is bad)
// Return on Marketing Investment = -1 (less is bad)
// Average Job Size = -1 (less is bad)
// Close Rate = -1 (less is bad)
// Cancellation Rate = 1 (more is bad)

const getGradientType = (name) => {
  if (name === 'Spend') return 0;
  if (
    [
      'Opportunities Generated',
      'Opportunities Closed',
      'Sales',
      'Return on Marketing Investment',
      'Average Job Size',
      'Close Rate',
    ].includes(name)
  ) {
    return -1;
  }
  if (['Cost per Opportunity', 'Cancellation Rate'].includes(name)) {
    return 1;
  }
  // for OppsByChannelTab
  if (
    ['Average_Job_Size', 'Yield_Gross', 'Close_Rate_Gross', 'Net_Conversion', 'romi'].includes(name)
  ) {
    return 2;
  }
  // for plan percentage fields
  if (['opps_perc_to_plan', 'spend_to_plan_ytd'].includes(name)) {
    return 3;
  }
};

export function getColorStyleForCell(rowName, value, totalBoolean) {
  let type = getGradientType(rowName);

  const val = {};
  // to avoid gradient color to total block
  if (totalBoolean) return val;

  if (![1, -1, 2, 3].includes(type)) {
    return val;
  }

  let parsedValue = parseFloat(value);
  if (!parsedValue && type !== 2 && type !== 3) {
    return val;
  }

  if (type === 1) {
    // Lower is green.. higher is red
    if (parsedValue < 100) {
      parsedValue = parsedValue <= 0 ? 1 : parsedValue;
      val.backgroundColor = perc2color(parsedValue / 100, LIGHT_GREEN, DARK_GREEN);
    } else {
      parsedValue = parsedValue - 100 || 1;
      parsedValue = parsedValue > 100 ? 100 : parsedValue;

      val.backgroundColor = perc2color(parsedValue / 100, DARK_RED_OPPS, LIGHT_RED);
    }
  } else if (type === 2) {
    // for OPPSBYCHANNEL TAB
    if (value?.percent < 0) return val;

    if (value?.percent >= value?.avgValueForColumn) {
      // green pallete
      val.backgroundColor = perc2color(value?.percent / 100, DARK_GREEN_OPPS, LIGHT_GREEN);
    } else if (value?.percent < value?.avgValueForColumn || value?.percent === 0) {
      // red pallete
      val.backgroundColor = perc2color(value?.percent / 100, LIGHT_RED, DARK_RED_OPPS);
    }
  } else if (type === 3) {
    // For opps_perc_to_plan and spend_to_plan_ytd
    // Below 75% red (increasing intensity as value decreases)
    // 75-90% no color
    // Above 90% green (increasing intensity as value increases)

    if (parsedValue >= 90) {
      // Scale from 90% to 110%+ for green gradient
      // Higher values = more intense green
      const greenPercentage = Math.min((parsedValue - 90) / 20, 1);
      val.backgroundColor = perc2color(greenPercentage, DARK_GREEN, LIGHT_GREEN);
    } else if (parsedValue < 75) {
      // Scale from 75% down to 50% or below for red gradient
      // Lower values = more intense red
      // For values below 50%, use maximum red intensity
      if (parsedValue <= 50) {
        val.backgroundColor = DARK_RED_OPPS; // Maximum red for <= 50%
      } else {
        // Map 75% -> 0 (light red) and 50% -> 1 (dark red)
        const redPercentage = (75 - parsedValue) / 25;
        val.backgroundColor = perc2color(redPercentage, DARK_RED_OPPS, LIGHT_RED);
      }
    }
    // For values between 75-90%, no color is applied (default cell background)
  } else {
    // Lower is red.. higher is green
    if (parsedValue >= 100) {
      parsedValue = parsedValue - 100 || 1;
      parsedValue = parsedValue > 100 ? 100 : parsedValue;

      val.backgroundColor = perc2color(parsedValue / 100, DARK_GREEN_OPPS, LIGHT_GREEN);
    } else {
      parsedValue = parsedValue <= 0 ? 1 : parsedValue;
      val.backgroundColor = perc2color(parsedValue / 100, LIGHT_RED, DARK_RED_OPPS);
    }
  }
  return val;
}
